export const DATA_IMPORTER_SCREEN = '/data-importer';
export const MACHINE_MANAGEMENT_SCREEN = '/machine-management';
export const ERROR_SCREEN = '*';
export const DEFAULT_SCREEN = '/';
